/**
 * Created by cxh on 3/12/2015.
 */
'use strict';
angular.module('dashboard', [
  'adf', 'structures', 'dashboard.vehicleList', 'dashboard.vehicleDetails', 'dashboard.vehicleMap', 'dashboard.fleetMap',
   'dashboard.driverWrkHrsDashboard', 'dashboard.driverWrkHrsSVG', 'dashboard.deviceSummary', 'dashboard.fmsDashboard', 'dashboard.driverDigitalTachoStatus', 'dashboard.tachoEventDetail',
   'dashboard.tachoHistory', 'dashboard.tachoDownloadDashboard'
]).config(function (dashboardProvider) {
  dashboardProvider.addLocale('de-DE',
    {
      ADF_COMMON_CLOSE: 'Schließen',
      ADF_COMMON_DELETE: 'Löschen',
      ADF_COMMON_TITLE: 'Titel',
      ADF_COMMON_CANCEL: 'Abbrechen',
      ADF_COMMON_APPLY: 'Anwenden',
      ADF_COMMON_EDIT_DASHBOARD: 'Dashboard bearbeiten',
      ADF_EDIT_DASHBOARD_STRUCTURE_LABEL: 'Struktur',
      ADF_DASHBOARD_TITLE_TOOLTIP_ADD: 'Neues Widget hinzufügen',
      ADF_DASHBOARD_TITLE_TOOLTIP_SAVE: 'Änderungen speichern',
      ADF_DASHBOARD_TITLE_TOOLTIP_EDIT_MODE: 'Editiermodus aktivieren',
      ADF_DASHBOARD_TITLE_TOOLTIP_UNDO: 'Änderungen verwerfen',
      ADF_WIDGET_ADD_HEADER: 'Neues Widget hinzufügen',
      ADF_WIDGET_DELETE_CONFIRM_MESSAGE: 'Sind Sie sicher, dass Sie dieses Widget löschen möchten ?',
      ADF_WIDGET_TOOLTIP_REFRESH: 'Inhalt aktualisieren',
      ADF_WIDGET_TOOLTIP_MOVE: 'Position ändern',
      ADF_WIDGET_TOOLTIP_COLLAPSE: 'Zusammenklappen',
      ADF_WIDGET_TOOLTIP_EXPAND: 'Vergrößern',
      ADF_WIDGET_TOOLTIP_EDIT: 'Einstellungen bearbeiten',
      ADF_WIDGET_TOOLTIP_FULLSCREEN: 'Vollbildanzeige',
      ADF_WIDGET_TOOLTIP_REMOVE: 'Löschen'
    }
  );
  dashboardProvider.addLocale('en-EN',
    {
      ADF_COMMON_CLOSE: 'Close',
      ADF_COMMON_DELETE: 'Delete',
      ADF_COMMON_TITLE: 'Title',
      ADF_COMMON_CANCEL: 'Cancel',
      ADF_COMMON_APPLY: 'Apply',
      ADF_COMMON_EDIT_DASHBOARD: 'Edit dashboard',
      ADF_EDIT_DASHBOARD_STRUCTURE_LABEL: 'Structure',
      ADF_DASHBOARD_TITLE_TOOLTIP_ADD: 'Add new widget',
      ADF_DASHBOARD_TITLE_TOOLTIP_SAVE: 'Save changes',
      ADF_DASHBOARD_TITLE_TOOLTIP_EDIT_MODE: 'Enable edit mode',
      ADF_DASHBOARD_TITLE_TOOLTIP_UNDO: 'Undo changes',
      ADF_WIDGET_ADD_HEADER: 'Add new widget',
      ADF_WIDGET_DELETE_CONFIRM_MESSAGE: 'Are you sure you want to delete this widget ?',
      ADF_WIDGET_TOOLTIP_REFRESH: 'Reload Widget Content',
      ADF_WIDGET_TOOLTIP_MOVE: 'Change widget location',
      ADF_WIDGET_TOOLTIP_COLLAPSE: 'Collapse widget',
      ADF_WIDGET_TOOLTIP_EXPAND: 'Expand widget',
      ADF_WIDGET_TOOLTIP_EDIT: 'Edit widget configuration',
      ADF_WIDGET_TOOLTIP_FULLSCREEN: 'Fullscreen widget',
      ADF_WIDGET_TOOLTIP_REMOVE: 'Remove widget'
    }
  );
  dashboardProvider.addLocale('nl-NL',
    {
      ADF_COMMON_CLOSE: 'Sluiten',
      ADF_COMMON_DELETE: 'Wissen',
      ADF_COMMON_TITLE: 'Titel',
      ADF_COMMON_CANCEL: 'Annuleren',
      ADF_COMMON_APPLY: 'Toepassen',
      ADF_COMMON_EDIT_DASHBOARD: 'Bewerk dashboard',
      ADF_EDIT_DASHBOARD_STRUCTURE_LABEL: 'Structuur',
      ADF_DASHBOARD_TITLE_TOOLTIP_ADD: 'Nieuwe wdget toevoegen',
      ADF_DASHBOARD_TITLE_TOOLTIP_SAVE: 'Opslaan',
      ADF_DASHBOARD_TITLE_TOOLTIP_EDIT_MODE: 'Bewerkingsmodus activeren',
      ADF_DASHBOARD_TITLE_TOOLTIP_UNDO: 'Ongedaan maken',
      ADF_WIDGET_ADD_HEADER: 'Nieuwe wdget toevoegen',
      ADF_WIDGET_DELETE_CONFIRM_MESSAGE: 'Weet u zeker dat u deze widget wilt verwijderen ?',
      ADF_WIDGET_TOOLTIP_REFRESH: 'Inhoud bijwerken',
      ADF_WIDGET_TOOLTIP_MOVE: 'Verander positie',
      ADF_WIDGET_TOOLTIP_COLLAPSE: 'Folden',
      ADF_WIDGET_TOOLTIP_EXPAND: 'Vergroten',
      ADF_WIDGET_TOOLTIP_EDIT: 'Instellingen bewerken',
      ADF_WIDGET_TOOLTIP_FULLSCREEN: 'Volledig scherm',
      ADF_WIDGET_TOOLTIP_REMOVE: 'Wissen'
    }
  );
});



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/dashboard.js